export const HEADER_HEIGHT = 32



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/utils/header.js